/**
 * Reducers para las secciones de cotizacion responsabilidad
 */

 /**
  * Imports
  */
 import { handleActions } from 'redux-actions';
 import {
  ambosCamposCotizResp,
  soloProfesionalCotizResp,
  soloInstitucionCotizResp,
  setTipoCaso,
} from '../actions/aCotizacionResponsabilidad';

/**
 * Reducers
 */
// estado inicial 
const initialState = {
  // Estado actual del cotizador responsabilidad
  estado: '',
  // campos que contienen ambos
  ambos: {},
  // campos que solo contiene profesional
  profesional: {},
  // campos que solo contiene institucion
  institucion: {},
};
// handle actions
const rCotizacionResp = handleActions(
  {
    // cotizacion responsabilidad profesional
    [ambosCamposCotizResp]: (state, action) => ({ ...state, ambos: action.payload }),
    [soloProfesionalCotizResp]: (state, action) => ({ ...state, profesional: action.payload }),
    [soloInstitucionCotizResp]: (state, action) => ({ ...state, institucion: action.payload }),
    [setTipoCaso]: (state, action) => ({ ...state, estado: action.payload }),

  },
  initialState
);

export default rCotizacionResp;


